import { render } from "./Setup.vue?vue&type=template&id=10ee47ab"
import script from "./Setup.vue?vue&type=script&lang=js"
export * from "./Setup.vue?vue&type=script&lang=js"
script.render = render

export default script